const LOGO = "/logo.jpeg";

export const BrandLogo = ({ height = 64, className = "" }) => (
  <div className={`bg-white rounded-xl p-1.5 inline-flex items-center justify-center shadow-sm ${className}`}>
    <img src={LOGO} alt="DIGI-LOANS — Loan Simplified" style={{ height }} className="object-contain" />
  </div>
);

export const Logo = ({ size = 40 }) => <BrandLogo height={size} />;

export const LogoWordmark = ({ light = false }) => <BrandLogo height={58} />;
